import {Component} from "react";
import {Button, Drawer, Image, Input, message, Modal, Space, Table, Tag} from "antd";
import {CheckOutlined, EyeOutlined, SearchOutlined} from "@ant-design/icons";
import {WindowParamContext} from "../../../../../library/context/WindowContext";
import {
    emptyOpinionPaginationData,
    handleOpinion,
    OpinionModel,
    OpinionPaginationData,
    queryOpinionByPage,
    QueryOpinionByPageReq
} from "../../../../data/opinion";
import {ColumnUnit} from "../../../../../library/atomic/unit/ColumnUnit";
import {SizeAttr} from "../../../../../library/basic/size";
import {ColumnAttr, RowAttr} from "../../../../../library/basic/compose";
import {RowUnit} from "../../../../../library/atomic/unit/RowUnit";
import {SpanText} from "../../../../../library/atomic/text/SpanText";
import {FontAttr} from "../../../../../library/basic/font";
import {ColumnsType} from "antd/es/table";

const {TextArea} = Input;

interface OpinionPanelState {
    detail_id: string;
    query_request: QueryOpinionByPageReq;
    query_data: OpinionPaginationData;
    handle_result: string;
    show_handle_modal: boolean;
    current_opinion: OpinionModel | null;
}

export class OpinionPanel extends Component<{}, OpinionPanelState> {
    static contextType = WindowParamContext;

    state: OpinionPanelState = {
        detail_id: "-1",
        query_request: {
            content: "",
            contact: "",
            dealt: undefined,
            page_num: 1,
            page_size: 10,
        },
        query_data: emptyOpinionPaginationData,
        handle_result: "",
        show_handle_modal: false,
        current_opinion: null
    }

    queryCertainPage(pageNum: number, pageSize: number) {
        let query_request = Object.assign({}, this.state.query_request, {
            page_num: pageNum,
            page_size: pageSize,
        });
        queryOpinionByPage(query_request, (success, resp) => {
            if (success && resp) {
                this.setState((prevState: OpinionPanelState) => (Object.assign(prevState,
                    {
                        query_request: query_request,
                        query_data: resp.data
                    }
                )))
                message.success("查询成功");
            } else {
                message.error("查询失败");
            }
        })
    }

    handleOperateClose() {
        this.setState((prevState: OpinionPanelState) => (Object.assign(prevState, {detail_id: "-1"})))
    }

    handleOpinionViewDetail(opinion: OpinionModel) {
        this.setState((prevState: OpinionPanelState) => (Object.assign(prevState, {
            detail_id: opinion.id,
            current_opinion: opinion
        })))
    }

    handleOpinionProcess(opinion: OpinionModel) {
        this.setState((prevState: OpinionPanelState) => (Object.assign(prevState, {
            current_opinion: opinion,
            show_handle_modal: true,
            handle_result: ""
        })))
    }

    handleOpinionConfirm() {
        if (!this.state.current_opinion) return;

        if (this.state.handle_result.trim() === "") {
            message.warning("处理结果不能为空");
            return;
        }

        handleOpinion(this.state.current_opinion.id, this.state.handle_result, (success, resp) => {
            if (success && resp) {
                message.success("处理成功");
                this.setState((prevState: OpinionPanelState) => (Object.assign(prevState, {
                    show_handle_modal: false,
                    handle_result: ""
                })))
                this.queryCertainPage(this.state.query_request.page_num, this.state.query_request.page_size);
            } else {
                message.error("处理失败");
            }
        })
    }

    handleOpinionCancel() {
        this.setState((prevState: OpinionPanelState) => (Object.assign(prevState, {
            show_handle_modal: false,
            handle_result: ""
        })))
    }

    componentDidMount() {
        this.queryCertainPage(1, 10);
    }

    OpinionColumn(): ColumnsType<OpinionModel> {
        return [
            {
                title: "ID",
                dataIndex: "id",
                key: "id",
                width: 80,
                render: (_, record) => record.id
            },
            {
                title: "用户ID",
                dataIndex: "user_id",
                key: "user_id",
                width: 100,
                render: (_, record) => record.user_id
            },
            {
                title: "反馈内容",
                dataIndex: "content",
                key: "content",
                width: 300,
                render: (_, record) => (
                    <div
                        style={{maxWidth: "280px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
                        {record.content}
                    </div>
                )
            },
            {
                title: "创建时间",
                dataIndex: "created_at",
                key: "created_at",
                width: 150,
                render: (_, record) => record.created_at
            },
            {
                title: "操作",
                key: "action",
                width: 150,
                render: (_, record) => (
                    <Space size="middle">
                        <Button
                            type="link"
                            icon={<EyeOutlined/>}
                            onClick={() => this.handleOpinionViewDetail(record)}
                        >
                            查看
                        </Button>
                        {record.dealt === 0 && (
                            <Button
                                type="link"
                                icon={<CheckOutlined/>}
                                onClick={() => this.handleOpinionProcess(record)}
                            >
                                处理
                            </Button>
                        )}
                    </Space>
                )
            }
        ]
    }

    render() {
        return (
            <WindowParamContext.Consumer>
                {wpt => {
                    let wp = wpt.param;

                    return (
                        <ColumnUnit sizeAttr={new SizeAttr(wp, "100vw")}>
                            {/*查询条件*/}
                            <RowUnit
                                sizeAttr={new SizeAttr(wp, "100vw")}
                                customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                                    "padding": "16px",
                                    "borderBottom": "1px solid #dee2e6"
                                })}
                            >
                                <RowUnit
                                    customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                                        "marginRight": "16px"
                                    })}
                                >
                                    <SpanText
                                        customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                                            "marginRight": "8px"
                                        })}
                                        fontAttr={new FontAttr(wp, "1em", "500")}>
                                        {"反馈内容:"}
                                    </SpanText>
                                    <Input
                                        value={this.state.query_request.content}
                                        onChange={(e) => {
                                            this.setState((prevState: OpinionPanelState) => (Object.assign(prevState, {
                                                query_request: Object.assign(prevState.query_request, {content: e.target.value})
                                            })))
                                        }}
                                        placeholder="请输入反馈内容关键词"
                                        style={{width: "200px"}}
                                    />
                                </RowUnit>

                                <RowUnit
                                    customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                                        "marginRight": "16px"
                                    })}
                                >
                                    <SpanText
                                        customStyleAttr={Object.assign(RowAttr.getChildrenPositionObj(), {
                                            "marginRight": "8px"
                                        })}
                                        fontAttr={new FontAttr(wp, "1em", "500")}>
                                        {"联系方式:"}
                                    </SpanText>
                                    <Input
                                        value={this.state.query_request.contact}
                                        onChange={(e) => {
                                            this.setState((prevState: OpinionPanelState) => (Object.assign(prevState, {
                                                query_request: Object.assign(prevState.query_request, {contact: e.target.value})
                                            })))
                                        }}
                                        placeholder="请输入联系方式"
                                        style={{width: "200px"}}
                                    />
                                </RowUnit>

                                <Button
                                    type="primary"
                                    icon={<SearchOutlined/>}
                                    onClick={() => {
                                        this.queryCertainPage(1, this.state.query_request.page_size);
                                    }}
                                >
                                    {"查询"}
                                </Button>
                            </RowUnit>

                            {/*数据表格*/}
                            <ColumnUnit
                                sizeAttr={new SizeAttr(wp, "100vw")}
                                customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                                    "padding": "16px"
                                })}
                            >
                                <Table
                                    columns={this.OpinionColumn()}
                                    dataSource={this.state.query_data.list}
                                    rowKey="id"
                                    pagination={{
                                        current: this.state.query_request.page_num,
                                        pageSize: this.state.query_request.page_size,
                                        total: this.state.query_data.total,
                                        showSizeChanger: true,
                                        showQuickJumper: true,
                                        showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条/共 ${total} 条`,
                                        onChange: (page, pageSize) => {
                                            this.queryCertainPage(page, pageSize || 10);
                                        }
                                    }}
                                />
                            </ColumnUnit>

                            {/*详情抽屉*/}
                            <Drawer
                                title="意见反馈详情"
                                placement="right"
                                onClose={this.handleOperateClose.bind(this)}
                                open={this.state.detail_id !== "-1"}
                                width={600}
                            >
                                {this.state.current_opinion && (
                                    <ColumnUnit
                                        sizeAttr={new SizeAttr(wp, "100%")}
                                        customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                                            "gap": "16px"
                                        })}
                                    >
                                        <RowUnit>
                                            <SpanText fontAttr={new FontAttr(wp, "1em", "600")}>ID: </SpanText>
                                            <SpanText>{this.state.current_opinion.id}</SpanText>
                                        </RowUnit>
                                        <RowUnit>
                                            <SpanText fontAttr={new FontAttr(wp, "1em", "600")}>用户ID: </SpanText>
                                            <SpanText>{this.state.current_opinion.user_id}</SpanText>
                                        </RowUnit>
                                        <RowUnit>
                                            <SpanText fontAttr={new FontAttr(wp, "1em", "600")}>反馈内容: </SpanText>
                                        </RowUnit>
                                        <div style={{
                                            padding: "12px",
                                            border: "1px solid #d9d9d9",
                                            borderRadius: "6px",
                                            backgroundColor: "#fafafa"
                                        }}>
                                            {this.state.current_opinion.content}
                                        </div>
                                        {this.state.current_opinion.images && this.state.current_opinion.images.length > 0 && (
                                            <>
                                                <RowUnit>
                                                    <SpanText
                                                        fontAttr={new FontAttr(wp, "1em", "600")}>图片: </SpanText>
                                                </RowUnit>
                                                <RowUnit>
                                                    {this.state.current_opinion.images.map((img: string, index: number) => (
                                                        <Image
                                                            key={index}
                                                            src={img}
                                                            alt={`图片${index + 1}`}
                                                            width={100}
                                                            height={100}
                                                            style={{
                                                                marginRight: "8px",
                                                                borderRadius: "4px"
                                                            }}
                                                            preview={{
                                                                mask: "点击查看大图",
                                                                maskClassName: "custom-mask"
                                                            }}
                                                        />
                                                    ))}
                                                </RowUnit>
                                            </>
                                        )}
                                        <RowUnit>
                                            <SpanText fontAttr={new FontAttr(wp, "1em", "600")}>联系方式: </SpanText>
                                            <SpanText>{this.state.current_opinion.contact}</SpanText>
                                        </RowUnit>
                                        <RowUnit>
                                            <SpanText fontAttr={new FontAttr(wp, "1em", "600")}>处理状态: </SpanText>
                                            <Tag color={this.state.current_opinion.dealt === 1 ? "green" : "orange"}>
                                                {this.state.current_opinion.dealt === 1 ? "已处理" : "未处理"}
                                            </Tag>
                                        </RowUnit>
                                        {this.state.current_opinion.handler && (
                                            <RowUnit>
                                                <SpanText fontAttr={new FontAttr(wp, "1em", "600")}>处理人: </SpanText>
                                                <SpanText>{this.state.current_opinion.handler}</SpanText>
                                            </RowUnit>
                                        )}
                                        {this.state.current_opinion.handle_result && (
                                            <>
                                                <RowUnit>
                                                    <SpanText
                                                        fontAttr={new FontAttr(wp, "1em", "600")}>处理结果: </SpanText>
                                                </RowUnit>
                                                <div style={{
                                                    padding: "12px",
                                                    border: "1px solid #d9d9d9",
                                                    borderRadius: "6px",
                                                    backgroundColor: "#f0f9ff"
                                                }}>
                                                    {this.state.current_opinion.handle_result}
                                                </div>
                                            </>
                                        )}
                                        <RowUnit>
                                            <SpanText fontAttr={new FontAttr(wp, "1em", "600")}>创建时间: </SpanText>
                                            <SpanText>{this.state.current_opinion.created_at}</SpanText>
                                        </RowUnit>
                                        <RowUnit>
                                            <SpanText fontAttr={new FontAttr(wp, "1em", "600")}>更新时间: </SpanText>
                                            <SpanText>{this.state.current_opinion.updated_at}</SpanText>
                                        </RowUnit>
                                    </ColumnUnit>
                                )}
                            </Drawer>

                            {/*处理意见反馈模态框*/}
                            <Modal
                                title="处理意见反馈"
                                open={this.state.show_handle_modal}
                                onOk={this.handleOpinionConfirm.bind(this)}
                                onCancel={this.handleOpinionCancel.bind(this)}
                                width={600}
                            >
                                {this.state.current_opinion && (
                                    <ColumnUnit
                                        sizeAttr={new SizeAttr(wp, "100%")}
                                        customStyleAttr={Object.assign(ColumnAttr.getChildrenPositionObj(), {
                                            "gap": "16px"
                                        })}
                                    >
                                        <RowUnit>
                                            <SpanText fontAttr={new FontAttr(wp, "1em", "600")}>反馈内容: </SpanText>
                                        </RowUnit>
                                        <div style={{
                                            padding: "12px",
                                            border: "1px solid #d9d9d9",
                                            borderRadius: "6px",
                                            backgroundColor: "#fafafa",
                                            maxHeight: "100px",
                                            overflow: "auto"
                                        }}>
                                            {this.state.current_opinion.content}
                                        </div>
                                        <RowUnit>
                                            <SpanText fontAttr={new FontAttr(wp, "1em", "600")}>处理结果: </SpanText>
                                        </RowUnit>
                                        <TextArea
                                            rows={4}
                                            value={this.state.handle_result}
                                            onChange={(e) => {
                                                this.setState((prevState: OpinionPanelState) => (Object.assign(prevState, {
                                                    handle_result: e.target.value
                                                })))
                                            }}
                                            placeholder="请输入处理结果..."
                                        />
                                    </ColumnUnit>
                                )}
                            </Modal>
                        </ColumnUnit>
                    )
                }}
            </WindowParamContext.Consumer>
        )
    }
} 